export const getComposedForm = `
  query GetComposedForm(
    $formName: String!
    $frontEndName: String!
    $clientName: String!
    $values: Any
  ) {
    composedForm(
      formName: $formName
      frontEndName: $frontEndName
      clientName: $clientName
      values: $values
    ) {
      id
      versionedId
      versionHash
      questions {
        name
        label
        description
        valueType
        queryType
        placeholder
        valueOptions {
          value
          display
          custom {
            cost {
              monthly {
                quantity
                text
                items {
                  rate
                  text
                  term
                }
              }
              onceOff {
                quantity
                text
                items {
                  rate
                  text
                  term
                }
              }
              name
            }
            discountDurationInMonths
            discountTariff
          }
        }
        value
        valueMapping
        unit
        defaultValue
        defaultValueExpression
        visibleExpression
        enabledExpression
        requiredExpression
        editableExpression
        validators
        custom {
          postback
        }
        mapping
      }
      layout {
        steps
      }
    }
  }
`;
